import copy from 'copy-to-clipboard';
import { Dialog } from 'vant';

export default function download(url) {
  copy(url);
  Dialog({ message: ' 学校VR地图，请转到浏览器查看!' });
}



// WEBPACK FOOTER //
// ./src/utils/VR.js